var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-block"},[_c('SearchInput',{attrs:{"placeholder":_vm.placeholder},on:{"on-search":function($event){return _vm.$emit('on-search', $event)},"clear-search":function($event){return _vm.$emit('clear-search')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }